document.addEventListener('DOMContentLoaded', function () {
	const grid = document.getElementById('product-grid');
	if (!grid) return;
	let currentPage = parseInt(grid.dataset.currentPage);
	const totalPages = parseInt(grid.dataset.totalPages);
	const baseUrl = grid.dataset.collectionUrl;

	let loading = false;

	const loadMore = () => {
		if (loading || currentPage >= totalPages) return;
		loading = true;
		const loader = document.getElementById('infinite-scroll-loader');
		if (loader) loader.style.display = 'block';

		const nextPage = currentPage + 1;
		const sectionId = grid.dataset.id;

		fetch(`${baseUrl}?page=${nextPage}&section_id=${sectionId}`)
			.then(res => res.text())
			.then(html => {
				const parser = new DOMParser();
				const doc = parser.parseFromString(html, 'text/html');
				const newItems = doc.querySelectorAll('#product-grid > li');
				newItems.forEach(item => grid.appendChild(item));

				currentPage++;
				grid.dataset.currentPage = currentPage;

				if (currentPage >= totalPages && loader) {
					loader.style.display = 'none';
				}

				loading = false;
			});
	};

	window.addEventListener('scroll', () => {
		if (
			window.innerHeight + window.scrollY >=
			document.body.offsetHeight - 300
		) {
			loadMore();
		}
	});
});
